import React from "react";
import { DataSource } from "../types";

export const DataSourceContext = React.createContext<DataSource>({} as DataSource);
